import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { forwardRefAndName } from "../../../../lib/forwardRefAndName";
import { BaseIcon } from "../../BaseIcon";
export var UiMenuDotsThreeVIcon20Regular = forwardRefAndName('UiMenuDotsThreeVIcon20Regular', function (props, ref) {
  return /*#__PURE__*/(
    React.createElement(BaseIcon, _extends({
      ref: ref,
      viewBoxSize: 20
    }, props), /*#__PURE__*/
    React.createElement("path", {
      d: "M11.56 3.76a1.56 1.56 0 1 1-3.12 0 1.56 1.56 0 0 1 3.12 0Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      d: "M11.56 10a1.56 1.56 0 1 1-3.12 0 1.56 1.56 0 0 1 3.12 0Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      d: "M10 17.8a1.56 1.56 0 1 0 0-3.12 1.56 1.56 0 0 0 0 3.12Z"
    }))
  );
});